import { render, staticRenderFns } from "./marksEntryStudent.vue?vue&type=template&id=342fee56&scoped=true&"
import script from "./marksEntryStudent.vue?vue&type=script&lang=js&"
export * from "./marksEntryStudent.vue?vue&type=script&lang=js&"
import style0 from "./marksEntryStudent.vue?vue&type=style&index=0&id=342fee56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342fee56",
  null
  
)

export default component.exports